<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        휴일사전대체신청
      </v-col>
    </v-row>

    <div class="apply-list px-6 overflow-y-auto">
      <v-text-field
        label="근무구분"
        v-model="workOrgNm"
        readonly
      ></v-text-field>
      <v-text-field
        label="근무구분코드"
        v-model="workOrgCd"
        v-show="false"
      ></v-text-field>
      <v-text-field
        label="휴일 근무일자"
        v-model="workYmd"
        readonly
      ></v-text-field>
      <v-text-field label="휴일 업무내용" v-model="note"></v-text-field>
      <div v-show="vShow">
        <v-text-field
          class="bottom--box"
          label="시업시간(휴일)"
          v-model="reqTime"
          readonly
          @click="flagTimeCd = !flagTimeCd"
          append-icon="mdi-chevron-right"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="시업시간(휴일)코드"
          v-model="reqTimeCd"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="추가휴게(휴일)"
          v-model="addRestTime"
          readonly
          @click="flagRestTime = !flagRestTime"
          append-icon="mdi-chevron-right"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="추가휴게(휴일)코드"
          v-model="addRestTimeCd"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="실 근무시간"
          v-model="reqHm"
          readonly
        ></v-text-field>
      </div>
      <v-text-field
        label="대체휴일"
        v-model="replacePeriod"
        readonly
      ></v-text-field>
      <v-text-field
        class="bottom--box"
        label="평일 대체 근무일자"
        @click="openModal('date_hol_replace_app')"
        v-model="replaceYmd"
        readonly
        append-icon="mdi-chevron-right"
      ></v-text-field>
      <div v-show="vShowReplace">
        <v-text-field
          class="bottom--box"
          label="시업시간(평일)"
          v-model="replaceReqTime"
          readonly
          @click="replaceFlagTimeCd = !replaceFlagTimeCd"
          append-icon="mdi-chevron-right"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="시업시간(평일)코드"
          v-model="replaceReqTimeCd"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="추가휴게(평일)"
          v-model="replaceAddRestTime"
          readonly
          @click="replaceFlagRestTime = !replaceFlagRestTime"
          append-icon="mdi-chevron-right"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="추가휴게(휴일)코드"
          v-model="replaceAddRestTimeCd"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="대체 근무시간"
          v-model="replaceReqHm"
          readonly
        ></v-text-field>
      </div>
      <div class="borderLine-wrap" v-show="fileShow">
        <span class="borderLine-title">첨부파일</span>
      <v-btn
          elevation="0"
          text
          fab
          width="24"
          height="24"
          class="ml-auto"
          @click="fileFlag = !fileFlag"
        >
          <v-icon size="24" color="#9ca3ab">mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
    <bgf-attach-file-add ref="bgfAttachFile" />
    <v-bottom-navigation fixed scroll-threshold="500" height="96">
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applovalPage"
          >
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
    <date-hol-replace-app-dialog />

    <v-bottom-sheet v-if="flagTimeCd" v-model="flagTimeCd">
      <bottom-sheet :title="selecttitle1" :default="reqTimeCd" :items="timeCdList" @selectItem="changeBottom1"></bottom-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-if="flagRestTime" v-model="flagRestTime">
      <bottom-sheet :title="selecttitle2" :default="addRestTimeCd" :items="restTimeCdList" @selectItem="changeBottom2"></bottom-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-if="replaceFlagTimeCd" v-model="replaceFlagTimeCd">
      <bottom-sheet :title="selecttitle1" :default="replaceReqTimeCd" :items="timeCdList" @selectItem="replaceChangeBottom1"></bottom-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-if="replaceFlagRestTime" v-model="replaceFlagRestTime">
      <bottom-sheet :title="selecttitle2" :default="replaceAddRestTimeCd" :items="restTimeCdList" @selectItem="replaceChangeBottom2"></bottom-sheet>
    </v-bottom-sheet>

<!--    <bottom-select-->
<!--      :flag="flagTimeCd"-->
<!--      :list="timeCdList"-->
<!--      :title="selecttitle1"-->
<!--      @selectItem="changeBottom1"-->
<!--    ></bottom-select>-->
<!--    <bottom-select-->
<!--      :flag="flagRestTime"-->
<!--      :list="restTimeCdList"-->
<!--      :title="selecttitle2"-->
<!--      @selectItem="changeBottom2"-->
<!--    ></bottom-select>-->
<!--    <bottom-select-->
<!--      :flag="replaceFlagTimeCd"-->
<!--      :list="timeCdList"-->
<!--      :title="selecttitle1"-->
<!--      @selectItem="replaceChangeBottom1"-->
<!--    ></bottom-select>-->
<!--    <bottom-select-->
<!--      :flag="replaceFlagRestTime"-->
<!--      :list="restTimeCdList"-->
<!--      :title="selecttitle2"-->
<!--      @selectItem="replaceChangeBottom2"-->
<!--    ></bottom-select>-->
    <bgf-attach-file-bottom-select
      :flag="fileFlag"
      @selectItem="changeFile"
    ></bgf-attach-file-bottom-select>
  </div>
</template>

<script>
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg
import { mapGetters, mapMutations } from 'vuex';
import {
  getWorkTimeCdList,
  getRestTimeCdList,
  getHolReplaceAppDetDupCnt,
  getWorkScheduleApplYn,
  getHolidayymdChgCheck,
} from '@/api/workStatus';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **
import DateHolReplaceAppDialog from '@/components/application/dialog/DateHolReplaceAppDialog.vue'; // modal component
import BottomSelect from '@/components/application/form/BottomSelect.vue';
import dayjs from 'dayjs';
import routerNames from '@/const/routerConstants';
import BgfAttachFileAdd from '@/components/application/form/BgfAttachFileAdd.vue';
import BgfAttachFileBottomSelect from '@/components/application/form/BgfAttachFileBottomSelect.vue';
import BottomSheet from "@/components/application/form/BottomSheet.vue";

export default {
  mixins: [dialogMixin],
  data: () => ({
    replaceYmd: '',
    workYmd: '',
    workOrgCd: '',
    workOrgNm: '',
    replacePeriod: '',
    note: '',
    bfTimeCd: '',
    bfTimeNm: '',
    startDate: '',
    endDate: '',
    vShow: false,
    vShowReplace: false,
    timeCdList: [],
    restTimeCdList: [],
    flagTimeCd: false,
    flagRestTime: false,
    replaceFlagTimeCd: false,
    replaceFlagRestTime: false,
    reqHm: '',
    reqSHm: '',
    reqEHm: '',
    reqTimeCd: '',
    reqTime: '',
    addRestTimeCd: '',
    restTime: '',
    addRestTime: '',
    replaceReqHm: '',
    replaceReqSHm: '',
    replaceReqEHm: '',
    replaceReqTimeCd: '',
    replaceReqTime: '',
    replaceAddRestTimeCd: '',
    replaceRestTime: '',
    replaceAddRestTime: '',
    selecttitle1: '근무시간',
    selecttitle2: '추가휴게',
    applGubun: '',
    replaceGubun: '',
    workYmdSave: '',
    fileShow: true,
    fileFlag: false,
  }),

  computed: {
    ...mapGetters('ELA', [
      'GET_APPL_SEQ_EXIST',
      'GET_REFER_USER_LIST',
      'GET_MGR_USER_LIST',
      'GET_UI_INFO',
      'GET_ELA_APPL_PARAM',
      'GET_APPL_USER_LIST',
      'GET_MGR_USER_LIST',
      'GET_VACCINATION_PARAM',
      'GET_S_YMD',
      'GET_E_YMD',
    ]),

    ...mapGetters([
      'GET_USER_DATA',
      'GET_WORK_TYPE_CD',
      'GET_NOTE1',
      'GET_WORK_TYPE_NM',
      'GET_REPLACE_YMD',
      'GET_HOL_REPLACE_DATA',
      'GET_HOL_REPLACE_PERIOD_DATA',
      'GET_WORK_YMD',
      'GET_PARAMS',
      'GET_FILE_SEQ'
    ]),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_BTN
      }px;`;
    },
  },

  methods: {
    ...mapMutations('DIALOG', ['SET_DIALOG_PARAM', 'TOGGLE_MODAL']),

    changeFile(levelObj) {
      if (levelObj === 'C') {
        this.$refs.bgfAttachFile.callCamera();
      } else if (levelObj === 'G') {
        this.$refs.bgfAttachFile.callGallery();
      }

      this.fileFlag = false;
    },

    openModal(modalNm) {
      this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
    },

    changeBottom1(levelObj) {
      this.reqTimeCd = levelObj.code;
      this.reqTime = levelObj.codeNm;
      this.reqSHm = levelObj.workShm;
      this.reqEHm = levelObj.workEhm + '';
      console.dir(levelObj);

      this.reqHm =
        this.reqSHm.substring(0, 2) +
        ':' +
        this.reqSHm.substring(2, 4) +
        ' ~ ' +
        this.reqEHm.substring(0, 2) +
        ':' +
        this.reqEHm.substring(2, 4);

      if (this.addRestTimeCd !== '') {
        this.restChange();
      }

      this.flagTimeCd = false;
    },

    changeBottom2(levelObj) {
      this.addRestTimeCd = levelObj.code;
      this.addRestTime = levelObj.codeNm;
      console.dir(levelObj);

      if (this.addRestTimeCd === '') this.addRestTimeCd = '0';

      let endTime = this.reqEHm;

      let hh = endTime.substring(0, 2);
      let mm = endTime.substring(2, 4);
      let date = new Date(2020, 1, 1, hh, mm);
      let addTime = parseFloat(this.addRestTimeCd, 10);

      let addHh = Math.ceil(addTime);
      let addMm = (addTime - addHh) * 60;
      date.setHours(date.getHours() + addHh);
      date.setMinutes(date.getMinutes() + addMm);

      this.reqHm =
        this.reqSHm.substring(0, 2) +
        ':' +
        this.reqSHm.substring(2, 4) +
        ' ~ ' +
        this.formatTime(
          (date.getHours() < 10 ? '0' : '') +
            date.getHours() +
            (date.getMinutes() < 10 ? '0' : '') +
            date.getMinutes(),
        );

      this.flagRestTime = false;
    },

    restChange() {
      let endTime = this.reqEHm;

      let hh = endTime.substring(0, 2);
      let mm = endTime.substring(2, 4);
      let date = new Date(2020, 1, 1, hh, mm);
      let addTime = parseFloat(this.addRestTimeCd, 10);

      let addHh = Math.ceil(addTime);
      let addMm = (addTime - addHh) * 60;
      date.setHours(date.getHours() + addHh);
      date.setMinutes(date.getMinutes() + addMm);

      this.reqHm =
        this.reqSHm.substring(0, 2) +
        ':' +
        this.reqSHm.substring(2, 4) +
        ' ~ ' +
        this.formatTime(
          (date.getHours() < 10 ? '0' : '') +
            date.getHours() +
            (date.getMinutes() < 10 ? '0' : '') +
            date.getMinutes(),
        );
    },

    replaceChangeBottom1(levelObj) {
      this.replaceReqTimeCd = levelObj.code;
      this.replaceReqTime = levelObj.codeNm;
      this.replaceReqSHm = levelObj.workShm;
      this.replaceReqEHm = levelObj.workEhm;

      this.replaceReqHm =
        this.replaceReqSHm.substring(0, 2) +
        ':' +
        this.replaceReqSHm.substring(2, 4) +
        ' ~ ' +
        this.replaceReqEHm.substring(0, 2) +
        ':' +
        this.replaceReqEHm.substring(2, 4);

      if (this.replaceAddRestTimeCd !== '') {
        this.replaceRestChange();
      }

      this.replaceFlagTimeCd = false;
    },

    replaceChangeBottom2(levelObj) {
      this.replaceAddRestTimeCd = levelObj.code;
      this.replaceAddRestTime = levelObj.codeNm;

      if (this.replaceAddRestTimeCd === '') this.replaceAddRestTimeCd = '0';

      let endTime = this.replaceReqEHm;

      let hh = endTime.substring(0, 2);
      let mm = endTime.substring(2, 4);
      let date = new Date(2020, 1, 1, hh, mm);
      let addTime = parseFloat(this.replaceAddRestTimeCd, 10);

      let addHh = Math.ceil(addTime);
      let addMm = (addTime - addHh) * 60;
      date.setHours(date.getHours() + addHh);
      date.setMinutes(date.getMinutes() + addMm);

      this.replaceReqHm =
        this.replaceReqSHm.substring(0, 2) +
        ':' +
        this.replaceReqSHm.substring(2, 4) +
        ' ~ ' +
        this.formatTime(
          (date.getHours() < 10 ? '0' : '') +
            date.getHours() +
            (date.getMinutes() < 10 ? '0' : '') +
            date.getMinutes(),
        );

      this.replaceFlagRestTime = false;
    },

    replaceRestChange() {
      let endTime = this.replaceReqEHm;

      let hh = endTime.substring(0, 2);
      let mm = endTime.substring(2, 4);
      let date = new Date(2020, 1, 1, hh, mm);
      let addTime = parseFloat(this.replaceAddRestTimeCd, 10);

      let addHh = Math.ceil(addTime);
      let addMm = (addTime - addHh) * 60;
      date.setHours(date.getHours() + addHh);
      date.setMinutes(date.getMinutes() + addMm);

      this.replaceReqHm =
        this.replaceReqSHm.substring(0, 2) +
        ':' +
        this.replaceReqSHm.substring(2, 4) +
        ' ~ ' +
        this.formatTime(
          (date.getHours() < 10 ? '0' : '') +
            date.getHours() +
            (date.getMinutes() < 10 ? '0' : '') +
            date.getMinutes(),
        );
    },

    formatTime(strDate, saper) {
      if (strDate == '' || strDate == null) {
        return '';
      }
      if (saper == '' || saper == null) saper = ':';
      if (strDate.length == 4) {
        return strDate.substring(0, 2) + saper + strDate.substring(2, 4);
      } else if (strDate.length == 6) {
        return (
          strDate.substring(0, 2) +
          saper +
          strDate.substring(2, 4) +
          saper +
          strDate.substring(4, 6)
        );
      }
    },

    async applovalPage() {
      if (this.note.trim() === '') {
        alert('휴일 업무내용을 입력해 주세요');
        return;
      }

      if (this.replaceYmd.trim() === '') {
        alert('평일 대체 근무 일자를 선택해 주세요');
        return;
      }

      if (this.vShow) {
        if (this.reqTime.trim() === '') {
          alert('근무시간(휴일)을 선택해 주세요');
          return;
        }
      }

      if (this.vShowReplace) {
        if (this.replaceReqTime.trim() === '') {
          alert('근무시간(휴일)을 선택해 주세요');
          return;
        }
      }

      const dupParam = {
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
      };

      const response = await getHolReplaceAppDetDupCnt(dupParam);

      if (response.data.data !== null) {
        alert(
          '동일한 일자에 신청내역이 있습니다. [' +
            (response.data.data.workCnt > 0
              ? ' 근무일자 중복'
              : ' 대체일자 중복') +
            ']',
        );

        return;
      }

      let param = {
        sYmd : this.GET_WORK_YMD.replaceAll('-', ''),
      }

      let res = await getWorkScheduleApplYn(param);

      if (res.data.data.chk === 'Y') {
        alert("해당 기간에 신청 중인 근태가 있습니다.");
        return;
      }

      param = {
        ymd : this.GET_WORK_YMD.replaceAll('-', ''),
      }

      res = await getHolidayymdChgCheck(param);

      if (res.data.data.chk === 'Y') {
        alert("해당 날짜에 휴일근무 사전 대체 신청건이 있어 입력할 수 없습니다.");
        return;
      }

      if (this.GET_UI_INFO.fileEssentialYn === 'Y') {
        if(this.GET_FILE_SEQ === '') {
          alert('파일 첨부는 필수 입니다');
          return;
        }
      }

      const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: this.GET_ELA_APPL_PARAM.searchApplCd,
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
        searchApplYmd: dayjs().format('YYYYMMDD'),
        searchApplName: this.GET_USER_DATA.ssnName,
        authPg: 'A', // A신청, R결제
        pathSeq: '',
        applStatusCd: '31', //수신처리중
        fileSeq: this.GET_FILE_SEQ,
        procExecYn: this.GET_UI_INFO.procExecYn,
        etc01: this.GET_UI_INFO.etc01,
        etc02: this.GET_UI_INFO.etc02,
        etc03: this.GET_UI_INFO.etc03,
        etc04: this.GET_UI_INFO.etc04,
        etc05: this.GET_UI_INFO.etc05,
        reqHm: this.reqHm,
        reqSHm: this.reqSHm,
        reqEHm: this.reqEHm,
        reqTimeCd: this.reqTimeCd,
        reqTime: this.reqTime,
        addRestTimeCd: this.addRestTimeCd,
        restTime: this.restTime,
        addRestTime: this.addRestTimeCd,
        replaceHm: this.replaceReqHm,
        replaceSHm: this.replaceReqSHm,
        replaceEHm: this.replaceReqEHm,
        replaceTimeCd: this.replaceReqTimeCd,
        replaceTime: this.replaceReqTime,
        replaceAddRestTimeCd: this.replaceAddRestTimeCd,
        replaceRestTime: this.replaceRestTime,
        replaceAddRestTime: this.replaceAddRestTimeCd,
        replaceYmd: this.replaceYmd,
        workYmd: this.workYmdSave,
        workOrgCd: this.workOrgCd,
        workOrgNm: this.workOrgNm,
        replacePeriod: this.replacePeriod,
        note: this.note,
        bfTimeCd: this.bfTimeCd,
        bfTimeNm: this.bfTimeNm,
        startDate: this.startDate,
        endDate: this.endDate,
        replaceBfTimeCd: this.GET_HOL_REPLACE_PERIOD_DATA.replaceBfTimeCd,
        replaceBfTimeNm: this.GET_HOL_REPLACE_PERIOD_DATA.replaceBfTimeNm,
        getBfTimeGb: this.GET_HOL_REPLACE_PERIOD_DATA.getBfTimeGb,
        replaceWorkOrgCd: this.GET_HOL_REPLACE_PERIOD_DATA.replaceWorkOrgCd,
        applGubun: this.applGubun,
        replaceGubun: this.GET_WORK_TYPE_CD,
      };

      // console.log('params ::: ' + JSON.stringify(params));

      this.$store.commit('SET_AUTHPG', 'A');
      this.$store.commit('SET_PARAMS', params);
      this.$store.dispatch('ELA/SET_HOL_REPLACE_PARAMS', params);
      this.$store.commit('SET_APPL_CD', '310');

      this.$router.push(routerNames.ApprovalLine);
    },
  },

  async mounted() {
    let param = {
      searchYn: 'Y',
      searchShortNameFlag: 'Y',
    };

    let response = await getWorkTimeCdList(param);
    for (let i = 0; i < response.data.data.length; i++) {
      if (this.GET_WORK_TYPE_CD === 'A') {
        // 전일
        if (response.data.data[i].timeGb === '10') {
          this.timeCdList.push(response.data.data[i]);
        }
      } else if (this.GET_WORK_TYPE_CD === 'H') {
        // 반일
        if (response.data.data[i].timeGb === '11') {
          this.timeCdList.push(response.data.data[i]);
        }
      }
    }

    param = {
      grpCd: 'T11030',
      note3: 'Y',
    };

    response = await getRestTimeCdList(param);

    this.restTimeCdList = response.data.data;

    this.workOrgCd = this.GET_HOL_REPLACE_DATA.workOrgCd;
    this.workOrgNm = this.GET_WORK_TYPE_NM;
    this.note1 = this.GET_NOTE1;

    this.applGubun = this.GET_HOL_REPLACE_DATA.applGubun;
    this.bfTimeCd = this.GET_HOL_REPLACE_DATA.bfTimeCd;
    this.bfTimeNm = this.GET_HOL_REPLACE_DATA.bfTimeNm;
    this.startDate = this.GET_HOL_REPLACE_DATA.startDate;
    this.endDate = this.GET_HOL_REPLACE_DATA.endDate;
    this.replacePeriod = this.startDate.substring(0, 4) + '-' + this.startDate.substring(4, 6) + '-' + this.startDate.substring(6, 8)
    + ' ~ ' + this.endDate.substring(0, 4) + '-' + this.endDate.substring(4, 6) + '-' + this.endDate.substring(6, 8) ;
    this.workYmdSave = this.GET_WORK_YMD;
    this.workYmd = this.workYmdSave + ' / ' + this.bfTimeNm;

    this.reqTime =
      this.GET_PARAMS.reqTime === undefined ? '' : this.GET_PARAMS.reqTime;
    this.reqTimeCd =
      this.GET_PARAMS.reqTimeCd === undefined ? '' : this.GET_PARAMS.reqTimeCd;
    this.replaceReqTime =
      this.GET_PARAMS.replaceReqTime === undefined
        ? ''
        : this.GET_PARAMS.replaceReqTime;
    this.replaceReqTimeCd =
      this.GET_PARAMS.replaceReqTiCd === undefined
        ? ''
        : this.GET_PARAMS.replaceReqTiCd;
    this.addRestTime =
      this.GET_PARAMS.addRestTime === undefined
        ? ''
        : this.GET_PARAMS.addRestTime;
    this.addRestTimeCd =
      this.GET_PARAMS.addRestTimeCd === undefined
        ? ''
        : this.GET_PARAMS.addRestTimeCd;
    this.reqHm =
      this.GET_PARAMS.reqHm === undefined ? '' : this.GET_PARAMS.reqHm;

    this.reqSHm =
      this.GET_PARAMS.reqSHm === undefined ? '' : this.GET_PARAMS.reqSHm;

    this.reqEHm =
      this.GET_PARAMS.reqEHm === undefined ? '' : this.GET_PARAMS.reqEHm;

    this.replaceYmd =
      this.GET_PARAMS.replaceYmd === undefined
        ? ''
        : this.GET_PARAMS.replaceYmd;
    this.replaceAddRestTime =
      this.GET_PARAMS.replaceAddRestTime === undefined
        ? ''
        : this.GET_PARAMS.replaceAddRestTime;
    this.replaceAddRestTimeCd =
      this.GET_PARAMS.replaceAddRestTimeCd === undefined
        ? ''
        : this.GET_PARAMS.replaceAddRestTimeCd;
    this.replaceReqHm =
      this.GET_PARAMS.replaceReqHm === undefined
        ? ''
        : this.GET_PARAMS.replaceReqHm;
    this.note = this.GET_PARAMS.note === undefined ? '' : this.GET_PARAMS.note;

    if (this.GET_HOL_REPLACE_PERIOD_DATA != null) {
      if (
        this.GET_HOL_REPLACE_PERIOD_DATA.getBfTimeGb === '03' ||
        this.GET_HOL_REPLACE_PERIOD_DATA.getBfTimeGb === '04' ||
        this.GET_HOL_REPLACE_PERIOD_DATA.getBfTimeGb === '08' ||
        this.GET_HOL_REPLACE_PERIOD_DATA.getBfTimeGb === '13'
      ) {
        this.vShow = false;
      } else {
        this.vShow = true;
      }

      // 전일, 반일
      if (this.GET_WORK_TYPE_CD === 'A') {
        this.vShowReplace = false;
      } else {
        this.vShowReplace = true;
      }
    }

    if (this.GET_UI_INFO.fileYn === 'N') {
      this.fileShow = false;
    }
  },

  setShow() {},

  components: {
    BottomSheet,
    IconApprovalDoc,
    DateHolReplaceAppDialog,
    BottomSelect,
    BgfAttachFileAdd,
    BgfAttachFileBottomSelect,
  },
};
</script>

<style>
/* _approval.scss 에 넣음 */
/* dialog */
/* .v-dialog:not(.v-bottom-sheet) {
  background-color: white;
  height: inherit;
} */
</style>
